export type Reference = {
  _id?: string;
  fsType?: string;
  displayName?: string;
  identifier?: string;
  uid?: string;
  locale?: {
    identifier?: string;
    country?: string;
    language?: string;
  };
  _etag?: {
    value: string;
  };
  url?: string;
};

export type FileMetaData = {
  fileSize: number;
  extension: string;
  mimeType: string; // 'application/pdf'
  encoding: string;
};

export type ResolutionsMetaData = {
  ORIGINAL: MediaBreakpoint;
  bannerDesktop?: MediaBreakpoint;
  bannerPhone?: MediaBreakpoint;
  bannerTablet?: MediaBreakpoint;
  rs_w140_h116_image?: MediaBreakpoint;
};

export type MediaBreakpoint = {
  fileSize: number;
  extension: string;
  mimeType: string;
  width: number;
  height: number;
  url: string;
};

export const ReferenceType = {
  Media: 'Media',
  PageRef: 'PageRef',
  GCAPage: 'GCAPage',
} as const;

export interface Media extends Reference {
  fsType?: typeof ReferenceType.Media;

  fileName: string;
  languageDependent: boolean;
  mediaType: string;
  description: string;
}

export interface File extends Media {
  url: string;
  fileMetaData: FileMetaData;
}

export interface Picture extends Media {
  remoteProject: string;
  resolutionsMetaData: ResolutionsMetaData;
}

export interface PageRef extends Reference {
  fsType?: typeof ReferenceType.PageRef | typeof ReferenceType.GCAPage | undefined | string;

  route: string;
}
